// src/components/UrlDialog.js
import React from 'react'
import { connect } from 'react-redux'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  // DialogTitle,
  withStyles,
} from '@material-ui/core'
import { toggleDialog } from 'actions/view'

const UrlDialog = ({ dialogOpen, toggleDialog, url, classes }) => {
  const handleClose = () => {
    toggleDialog({
      open: false,
      dialog: 'UrlDialog',
    })
  }

  return (
    <Dialog
      fullScreen
      open={Boolean(dialogOpen)}
      onClose={handleClose}
      aria-labelledby="iframe-dialog-title"
      maxWidth="xl"
      fullWidth
      PaperProps={{ classes: { rounded: classes.rounded } }}
    >
      {/* <DialogTitle id="iframe-dialog-title">View URL</DialogTitle> */}
      <DialogContent classes={{ root: classes.dialogContentRoot }}>
        {dialogOpen && url ? (
          <iframe
            src={url}
            width="100%"
            height="500px"
            title="Iframe Dialog"
            style={{ border: 'none' }}
          />
        ) : null}
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogActionsRoot }}>
        <Button onClick={handleClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = state => ({
  dialogOpen: state.view.dialogs?.UrlDialog?.open,
  url: state.view.dialogs?.UrlDialog?.url,
})

const mapDispatchToProps = {
  toggleDialog,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  withStyles(theme => ({
    rounded: {
      // borderRadius: 28,
      // overflowY: 'hidden',
      // // height: '100%',
      // [theme.breakpoints.down('sm')]: {
      borderRadius: 0,
      overflowY: 'auto',
      // },
    },
    dialogContentRoot: {
      position: 'relative',
      padding: 0,
      '&:first-child': {
        paddingTop: 0,
      },
    },
    dialogActionsRoot: {
      display: 'block',
      margin: 0,
    },
  }))(UrlDialog),
)
